import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/fila`

    return {
        index(queryParms) {
            return repository.get(`${baseUrl}?${urlUtil.serialize(queryParms)}`)
        },
        create() {
            return repository.get(`${baseUrl}/create`)
        },
        store(params) {
            return repository.post(`${baseUrl}`, params)
        },
        show(id) {
            return repository.get(`${baseUrl}/${id}`)
        },
        destroy(id) {
            return repository.delete(`${baseUrl}/${id}`)
        },
        answer(id) {
            return repository.patch(`${baseUrl}/${id}/answer`)
        },
        forward(id, params) {
            return repository.patch(`${baseUrl}/${id}/forward`, params)
        },
        evade(id, params) {
            return repository.patch(`${baseUrl}/${id}/evade`, params)
        },
    }
}